<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import FaqsTable from './FaqsTable';


export default {
  page: {
    title: 'FAQ',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, FaqsTable },
  data() {
    let $this = this;
    return {
      title: 'FAQ',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'FAQ', active: true, },
      ],

      loading: true,
      filters: {
        whereins: {
          website: [],
        },
      },
    }
  },
  created() {
    this.filters.whereins.website = [this.website_id];
  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <FaqsTable ref="FaqsTable" :changefilters="filters"  @loadchange="(e) => {loading = e;}"></FaqsTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


